'use client';

import { c as _c } from "react/compiler-runtime";
import { motion } from 'motion/react';
import { useFadeInSection } from '@/modules/home/components/fade-in-section';
import type { ComponentProps } from 'react';
type AnimatedSubtitleProps = (ComponentProps<typeof motion.p> & {
  as?: 'p';
}) | (ComponentProps<typeof motion.div> & {
  as: 'div';
});
const initial = {
  opacity: 0,
  scale: 0.97,
  y: 16
};
const transition = {
  delay: 0.1,
  duration: 0.35,
  ease: 'easeOut' as const
};
function AnimatedSubtitle(props) {
  const $ = _c(16);
  const isInView = useFadeInSection();
  let t0;
  if ($[0] !== isInView) {
    t0 = isInView ? {
      opacity: 1,
      scale: 1,
      y: 0
    } : initial;
    $[0] = isInView;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const animate = t0;
  if (props.as === "div") {
    let children;
    let rest;
    if ($[2] !== props) {
      const {
        as: _as,
        children: t1,
        ...t2
      } = props;
      children = t1;
      rest = t2;
      $[2] = props;
      $[3] = children;
      $[4] = rest;
    } else {
      children = $[3];
      rest = $[4];
    }
    let t1;
    if ($[5] !== animate || $[6] !== children || $[7] !== rest) {
      t1 = <motion.div {...rest} animate={animate} initial={initial} transition={transition}>{children}</motion.div>;
      $[5] = animate;
      $[6] = children;
      $[7] = rest;
      $[8] = t1;
    } else {
      t1 = $[8];
    }
    return t1;
  }
  let children_0;
  let rest_0;
  if ($[9] !== props) {
    const {
      as: _as_0,
      children: t1,
      ...t2
    } = props;
    children_0 = t1;
    rest_0 = t2;
    $[9] = props;
    $[10] = children_0;
    $[11] = rest_0;
  } else {
    children_0 = $[10];
    rest_0 = $[11];
  }
  let t1;
  if ($[12] !== animate || $[13] !== children_0 || $[14] !== rest_0) {
    t1 = <motion.p {...rest_0} animate={animate} initial={initial} transition={transition}>{children_0}</motion.p>;
    $[12] = animate;
    $[13] = children_0;
    $[14] = rest_0;
    $[15] = t1;
  } else {
    t1 = $[15];
  }
  return t1;
}
export { AnimatedSubtitle };